<template>
  <div
    tabindex="0"
    class="modal-container">
    <div
      class="modal-content"
      :class="size">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
    },
    customClass: {
      type: String,
    },
  },
  methods: {
    onCloseModal() {
      this.$emit('modalClose');
      document.body.classList.remove('modal-open');
    },
  },
  mounted() {
    document.body.classList.add('modal-open');
    window.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.onCloseModal();
      }
    });
  },
  destroyed() {
    document.body.classList.remove('modal-open');
    window.removeEventListener('keydown', this.onCloseModal, true);
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/helpers.scss';

// animate
.slide-bottom {
  -webkit-animation: slide-bottom 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation: slide-bottom 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@-webkit-keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(-60px);
            transform: translateY(-60px);
  }

  100% {
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
  }
}

@keyframes slide-bottom {
  0% {
    -webkit-transform: translateY(-60px);
            transform: translateY(-60px);
  }
  100% {
    -webkit-transform: translateY(0px);
            transform: translateY(0px);
  }
}

.modal-container {
  display: block;
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);

  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  @extend .slide-bottom;
  background-color: #fefefe;
  border: 1px solid $gray-400;
  width: 550px;
}

.modal-header {
  padding: $spacer;
  text-align: left;
  color: $gray-700;
  position: relative;

  .btn-close-container {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: $font-size-lg;
  }

  * {
    margin-bottom: 0;
  }
}

.modal-body {
  @extend .scrollbar;
  padding: $spacer;
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: 80vh;
  &.no-padding {
    padding: $spacer 0;
  }
}

.modal-footer {
  padding: $spacer * 0.5 $spacer;
  display: flex;
  width: 100%;
  justify-content: flex-start;

  .btn-remove {
    padding-left: 0;
  }

  .btn {
    &:last-child {
      margin-left: auto;
    }
  }
}

// dialog

.dialog {
  width: 350px;
  .modal-header {
    border: none;
    padding: $spacer * 1 $spacer * 1.5;
  }
  .modal-body {
    padding: $spacer * 1 $spacer * 1.5;
  }
  .modal-footer {
    border: none;
    padding: $spacer * 1 $spacer * 1.5;
  }
}

// sizing

.small {
  width: 450px;
}

.large {
  width: 750px;
}

.larger {
  width: 900px;
  max-width: calc(100vw - 10%);
}

.largest {
  width: 70vw;
  max-width: 1160px;
}

@media (max-width: 576px) {
  .modal-content {
    width: 100%;
    max-width: 550px;
    position: relative;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;

    &.small {
      max-width: 450px;
    }

    &.large {
      max-width: 750px;
    }

    &.larger {
      max-width: calc(100vw - 10%);
    }
  }

  .modal-body {
    overflow-y: auto;
    height: 100%;
  }

  .modal-header {
    // padding: $spacer $spacer * 0.5;
  }
}


@media (min-width: 576px) and (max-width: 991.98px) {
  .modal-content {
    width: calc(100vw - 10vw);
    max-width: 550px;
    position: relative;
    pointer-events: auto;

    &.small {
      max-width: 450px;
    }

    &.large {
      max-width: 750px;
    }

    &.larger {
      max-width: calc(100vw - 10%);
    }
  }

  .modal-body {
    padding: $spacer;
    overflow-y: auto;
    height: 100%;
  }
 }
</style>
